import { ReactNode } from 'react';
// import { useAccount, useConnect } from 'wagmi';

// web3 세션 안 끊기게 연결해주는 역할
export const SessionRefresh = ({ children }: { children: ReactNode }) => {
  // const { connect, connectors, pendingConnector } = useConnect();
  // const { isDisconnected } = useAccount();
  // console.log(`SessionRefresh`);
  // console.log(children);
  // useEffect(() => {
  //   if (!isDisconnected) return;

  //   // if wagmi.connected set to true, then wagmi will not show modal
  //   // to reconnect user wallet, but instead will use prev connection
  //   // I found this example in this public repo: https://github.com/sumicet/web3auth-modal-wagmi
  //   const wagmiConnected = localStorage.getItem('wagmi.connected');
  //   const isWagmiConnected = wagmiConnected ? JSON.parse(wagmiConnected) : false;

  //   if (!isWagmiConnected) return;
  //   connect({ connector: connectors[0] });
  // }, [connect, connectors]);

  return <>{children}</>;
};
